import { defineMessages } from 'react-intl';

/** The copy of the wish box (design wish-box a1-a8). */
export const wishBoxMessages = defineMessages({
  entry: { id: 'app.sml.wishBox.entry', defaultMessage: 'Tell us what is missing' },
  title: { id: 'app.sml.wishBox.title', defaultMessage: 'What do you wish MUSIC24 could do?' },
  body: {
    id: 'app.sml.wishBox.body',
    defaultMessage: 'Pick a topic. We read every wish, and the most common wishes shape what we build next.',
  },
  topicsLabel: { id: 'app.sml.wishBox.topicsLabel', defaultMessage: 'Topic' },
  topicStudio: { id: 'app.sml.wishBox.topic.studio', defaultMessage: 'Studio and Release Kit' },
  topicPromote: { id: 'app.sml.wishBox.topic.promote', defaultMessage: 'Promote and posting' },
  topicSmartlinks: { id: 'app.sml.wishBox.topic.smartlinks', defaultMessage: 'SmartLinks' },
  topicOutreach: { id: 'app.sml.wishBox.topic.outreach', defaultMessage: 'Outreach' },
  topicAnalytics: { id: 'app.sml.wishBox.topic.analytics', defaultMessage: 'Stats and Intelligence' },
  topicOther: { id: 'app.sml.wishBox.topic.other', defaultMessage: 'Something else' },
  noteLabel: { id: 'app.sml.wishBox.noteLabel', defaultMessage: 'Your note' },
  notePlaceholder: { id: 'app.sml.wishBox.notePlaceholder', defaultMessage: 'Tell us more (optional)' },
  teamOnly: { id: 'app.sml.wishBox.teamOnly', defaultMessage: 'Only our team reads this.' },
  count: { id: 'app.sml.wishBox.count', defaultMessage: '{count} / {max}' },
  failedTitle: { id: 'app.sml.wishBox.failedTitle', defaultMessage: 'We could not send your wish.' },
  failedBody: { id: 'app.sml.wishBox.failedBody', defaultMessage: 'Nothing changed. Try again in a moment.' },
  notNow: { id: 'app.sml.wishBox.notNow', defaultMessage: 'Not now' },
  send: { id: 'app.sml.wishBox.send', defaultMessage: 'Send my wish' },
  sentTitle: { id: 'app.sml.wishBox.sentTitle', defaultMessage: 'Thanks. Your wish is with us.' },
  sentBody: {
    id: 'app.sml.wishBox.sentBody',
    defaultMessage:
      'We read every wish. We cannot answer each one, but the most common wishes shape what we build next.',
  },
  done: { id: 'app.sml.wishBox.done', defaultMessage: 'Done' },
});
